module.exports = __webpack_public_path__ + "img/firma_template6.135348a.svg";